///////////////////////////////////////////////////

import { liveQuoteFormApiConnector } from 'apiConnector/secondary-market/live/form';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import { liveInputFormActions } from 'state/secondaryMarket/live/form/input/inputForm.actions';
import type { EpicWithThunk } from 'state/state.common';
import { mapErrorKind } from 'utils/errors/errors';
import type { HttpError } from 'utils/http/httpClient.model';

import { liveThunks } from '../../../state/secondaryMarket/live/live.thunk';
import { getTabRemoved$ } from '../utils';

export function reloadLiveTabContentEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { init } = liveQuoteFormApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_LIVE_RELOAD_FORM_FETCH_REQUESTED'),
      mergeMap(({ request, tabId, workspace }) => {
        return init(request).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(response => liveThunks.reloadFormFetchedThunk(tabId, workspace, response)),
          catchError((err: HttpError) =>
            of(liveInputFormActions.reloadFormFetchFailed(tabId, workspace, err?.payload?.message, mapErrorKind(err))),
          ),
        );
      }),
    );
  };
}
